import { ColumnDef } from '@tanstack/table-core';
import { StockFacilityResult, StockFilterOption } from '../../types/Stock';

const NO_VALUE = '\u2014';
export const TOTAL_ROW_ID = '__total__';

export const makeStockFacilityColumns = (uldTypes: StockFilterOption[]): ColumnDef<StockFacilityResult>[] => {
  const uldColumns: ColumnDef<StockFacilityResult>[] = uldTypes.map((uld) => ({
    id: uld.value,
    header: uld.label,
    enableSorting: false,
    enableColumnFilter: false,
    size: 90,
    cell: ({ row }) => {
      const match = row.original.byUldType.find((b) => b.uldGroupId === uld.value);
      return match ? match.totalCount : NO_VALUE;
    },
  }));

  return [
    {
      header: 'Facility',
      accessorKey: 'facilityName',
      enableSorting: false,
      enableColumnFilter: false,
      size: 220,
      cell: ({ row }) => {
        const isTotal = row.original.facilityId === TOTAL_ROW_ID;
        return <span style={isTotal ? { fontWeight: 600 } : undefined}>{isTotal ? 'Total' : (row.original.facilityName ?? 'Unassigned')}</span>;
      },
    },
    {
      header: () => <span style={{ fontWeight: 700, padding: '2px 6px', borderRadius: 4 }}>Total</span>,
      accessorKey: 'totalCount',
      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      cell: ({ row }) => <span style={{ fontWeight: 700, padding: '2px 6px', borderRadius: 4 }}>{row.original.totalCount}</span>,
    },
    ...uldColumns,
  ];
};

// Builds a synthetic Total row shaped like StockFacilityResult, so the
// column cell renderers above work on it unmodified. Only sums the rows
// currently loaded (i.e. the current page under server-side pagination) —
// see note in StockDetails.tsx if a true cross-page total is needed later.
export const buildStockTotalsRow = (rows: StockFacilityResult[], uldTypes: StockFilterOption[]): StockFacilityResult => ({
  facilityId: TOTAL_ROW_ID,
  facilityName: 'Total',
  location: { type: 'Point', longitude: 0, latitude: 0 },
  totalCount: rows.reduce((sum, r) => sum + r.totalCount, 0),
  taggedCount: 0,
  seenCount: 0,
  unseenCount: 0,
  byCarrier: [],
  isSeen: false,
  byUldType: uldTypes.map((uld) => ({
    uldGroupId: uld.value,
    uldGroupIataCode: uld.label,
    totalCount: rows.reduce((sum, r) => sum + (r.byUldType.find((b) => b.uldGroupId === uld.value)?.totalCount ?? 0), 0),
    taggedCount: 0,
    seenCount: 0,
    unseenCount: 0,
  })),
});
